import { useQuery } from "@tanstack/react-query"

import api from "../../api"

const useTagsByGCPProjectId = (
  gcpProjectId: string,
  options?: { enabled?: boolean }
) => {
  const enabled =
    options?.enabled ??
    Boolean(gcpProjectId && gcpProjectId.trim())

  return useQuery({
    queryKey: ['tags', gcpProjectId],
    queryFn: () => api.tags.getTagsByGCPProjectId(gcpProjectId),
    enabled,
    select(data) {
      let response = data && data.body[0]
      return response
    }
  })
}

export default useTagsByGCPProjectId